import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { imgLinks } from '../../shared';
import { useCompanyLogo } from '../../hooks/useIcons';
import useInsuranceInfo from '../../hooks/useInsuranceInfo';
import MaintenanceBanner from './MaintenanceBanner';

import {
  StyledCompanyLogoButton,
  StyledDaDirektLogo,
  StyledHeader,
  StyledHeaderContainer,
  StyledHeaderLogoLinks,
  StyledHeaderSticky,
} from './Header.styled';

function HeaderWithoutActions({ location }) {
  const { type: insuranceType } = useInsuranceInfo();
  const companyLogo = useCompanyLogo();

  const params = queryString.parse(location?.search);

  const customerSourceZurich = params.customer_source === 'zurich';

  return (
    <>
      <StyledHeader>
        <StyledHeaderSticky data-header-menu>
          <StyledHeaderContainer>
            <StyledHeaderLogoLinks>
              <StyledCompanyLogoButton to="/" aria-label="go to homepage">
                <img src={imgLinks[`${companyLogo}`]} alt={insuranceType} />
              </StyledCompanyLogoButton>

              {customerSourceZurich && (
                <StyledDaDirektLogo src={imgLinks['icon.menu.dadirekt.dark']} alt="DaDirekt" />
              )}
            </StyledHeaderLogoLinks>
          </StyledHeaderContainer>
        </StyledHeaderSticky>
      </StyledHeader>

      <MaintenanceBanner />
    </>
  );
}

HeaderWithoutActions.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default withRouter(HeaderWithoutActions);
